import palette from '../palette';

export default {
  root: {
    borderBottom: '1px solid' + palette.divider,
  },
};
